import { CircularCountdown, WarningIcon } from 'components/shared/PriceNext';
import { ProgressBar } from 'components/shared/ProgressBar/ProgressBar';
import { FormattedMessage } from 'react-intl';

type EbizQuoteStatusProps = {
  price: string;
  remainingTimeInSeconds: number;
  progressInPercent: number;
  hasBackendMessage: boolean;
  tradeWay: string;
  onCancelAction?: () => void;
};

const EbizQuoteStatus = ({
  tradeWay,
  price,
  remainingTimeInSeconds,
  progressInPercent,
  hasBackendMessage,
  onCancelAction,
}: EbizQuoteStatusProps) => {
  return (
    <div className={`alert-discreet-${tradeWay} text-${tradeWay} h-100 px-3 flex-grow-1`}>
      <div className="d-flex align-items-center gap-2">
        <span className="quote-ico">{CircularCountdown}</span>
        <div className="fw-bold flex-grow-1">{price}</div>
        <FormattedMessage id="sidePanel.countdown.seconds" values={{ value: remainingTimeInSeconds }} />
        {hasBackendMessage && WarningIcon}
        {onCancelAction && (
          <span className="btn btn-icon cursor-pointer" onClick={onCancelAction}>
            <i className={`icon text-${tradeWay}`}>close</i>
          </span>
        )}
      </div>
      <ProgressBar percent={100 - progressInPercent} className={`progress-elapsed-${tradeWay}`} />
    </div>
  );
};

export default EbizQuoteStatus;
